import React from 'react';
import { Text, Flex } from '@chakra-ui/react';
import { GenericSubmissionField } from '../MySubmission/FormFieldGeneric/GenericSubmissionField';

const PreferencesTab: React.FC<{}> = () => {
  return (
    <Flex gap={4} flexDirection="column">
      <Text textStyle="headingSection">Submission Preferences</Text>

      <GenericSubmissionField fieldName="CommentForEditor" />

      <GenericSubmissionField fieldName="CoAuthorApproval" />

      <GenericSubmissionField fieldName="PublishingModel" />

      <GenericSubmissionField fieldName="OpenAccessChoice" />

      <GenericSubmissionField fieldName="OpenAccessChoiceWorldBankACountry" />

      <GenericSubmissionField fieldName="OpenAccessChoiceWorldBankBCountry" />

      <GenericSubmissionField fieldName="OpenAccessChoiceReviewerDiscountRate" />

      <GenericSubmissionField fieldName="PreferenceImmediatePublication" />

      <GenericSubmissionField fieldName="Funding" />

      <GenericSubmissionField fieldName="FundingGeneric" />

      <GenericSubmissionField fieldName="TransparentPeerReview" />

      <GenericSubmissionField fieldName="DoubleAnonymousPeerReview" />

      <GenericSubmissionField fieldName="RecommendedReviewers" />

      <GenericSubmissionField fieldName="OpposedReviewers" />

      <GenericSubmissionField fieldName="NoveltyStatement" />

      <GenericSubmissionField fieldName="DataAvailability" />

      <GenericSubmissionField fieldName="DataAvailabilityOpenlyAvailableUrl" />

      <GenericSubmissionField fieldName="DataAvailabilityEmbargoUrl" />

      <GenericSubmissionField fieldName="DataAvailabilityEmbargoDate" />

      <GenericSubmissionField fieldName="DataUnavailabilityReason" />

      <GenericSubmissionField fieldName="DataAvailabilityStatement" />

      <GenericSubmissionField fieldName="ClinicalTrials" />

      <GenericSubmissionField fieldName="EthicsStatement" />

      <GenericSubmissionField fieldName="AcceleratedPublication" />

      <GenericSubmissionField fieldName="IPEMMembership" />

      <GenericSubmissionField fieldName="SubjectArea" />

      <GenericSubmissionField fieldName="PreviouslySubmitted" />

      <GenericSubmissionField fieldName="ConflictOfInterestForAuthor" />

      <GenericSubmissionField fieldName="AITools" />

      <GenericSubmissionField fieldName="Preprint" />

      <GenericSubmissionField fieldName="SharedDataset" />

      <GenericSubmissionField fieldName="EthicalApproval" />

      <GenericSubmissionField fieldName="EthicsApproval" />

      <GenericSubmissionField fieldName="CopyrightLicensingForm" />

      <GenericSubmissionField fieldName="Volume" />

      <GenericSubmissionField fieldName="Issue" />

      <GenericSubmissionField fieldName="GeneratedDataset" />

      <GenericSubmissionField fieldName="UtilizedDataset" />
    </Flex>
  );
};

export default PreferencesTab;
